import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "../../tenant/tenant-list/tenant-filter-options/filter-options-tenant.scss";
import { useFormikContext } from "formik";
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DateRaisedFilterProps } from "../types";

const DateRaisedFilter: React.FC<DateRaisedFilterProps> = ({
  startDate,
  endDate,
  onDateRangeChange,
  startDateError,
  endDateError,
  startDateFieldName,
  endDateFieldName,
}) => {
  const { values, setFieldValue, touched, errors, setFieldError, validateForm } = useFormikContext<any>();
  const [fromDate, setFromDate] = useState<Dayjs | null>(
    startDate ? dayjs(startDate) : null
  );
  const [toDate, setToDate] = useState<Dayjs | null>(
    endDate ? dayjs(endDate) : null
  );
  const [errorStart, setErrorStart] = useState<string | null>(
    startDateError ?? null
  );
  const [errorEnd, setErrorEnd] = useState<string | null>(endDateError ?? null);

  const handleStartDateChange = (newValue: Dayjs | null) => {
     onDateRangeChange(newValue, values?.[endDateFieldName] || null);
  };

  const handleEndDateChange = (newValue: Dayjs | null) => {
    onDateRangeChange(values?.[startDateFieldName] || null, newValue);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box className="tenant-filter-date-input-wrapper">
        <DesktopDatePicker
          label="From Date"
          value={values?.[startDateFieldName] || null}
          onChange={handleStartDateChange}
          maxDate={values?.[endDateFieldName] || null}
          minDate={dayjs("1900-01-01")}
          disableFuture
          shouldDisableDate={(date) =>
            !!(values?.[endDateFieldName] && date.isAfter(values?.[endDateFieldName])) || date.isAfter(dayjs())
          }
          slotProps={{
            textField: {
              size: "small",
              fullWidth: true,
              error: !!startDateError,
              helperText: startDateError,
              sx: {
                "& label.MuiInputLabel-shrink": {
                  fontSize: "12px",
                  padding: "0",
                  margin: "0",
                },
              },
            },
          }}
        />
        <DesktopDatePicker
          label="To Date"
          value={values?.[endDateFieldName] || null}
          onChange={handleEndDateChange}
          minDate={
            values?.[startDateFieldName] && values?.[startDateFieldName].isBefore(dayjs("1900-01-01"))
              ? dayjs("1900-01-01")
              : (values?.[startDateFieldName] ?? undefined)
          }
          maxDate={dayjs()}
          disableFuture
          shouldDisableDate={(date) =>
            !!(values?.[startDateFieldName] && date.isBefore(values?.[startDateFieldName])) || date.isAfter(dayjs())
          }
          slotProps={{
            textField: {
              size: "small",
              fullWidth: true,
              error: !!endDateError,
              helperText: endDateError,
              sx: {
                "& label.MuiInputLabel-shrink": {
                  fontSize: "12px",
                  padding: "0",
                  margin: "0",
                },
              },
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default DateRaisedFilter;
